// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-LibKey-LibkeyLibrarySection-LibkeyLibrarySection-module__Logo";
export { _1 as "Logo" }
